import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createTankHistoryApi } from '@/apis/tankHistories'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { SuccessResponse } from '@/types'
import { CreateTankHistoryRequest } from '@/types/apis/tankHistory/CreateTankHistoryRequest'

export const useCreateTankHistory = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<SuccessResponse>()

  const create = useCallback(
    async (request: CreateTankHistoryRequest) => {
      try {
        setLoading(true)
        const res = await createTankHistoryApi(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        const path = routes.tankHistories.path.replace(':id', request.tankId.toString())
        navigate(path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createTankHistory: create,
    response,
  }
}
